/**
 * @file 文档反馈
 * @author Wanzhongyun
 */

import React, { useState, useRef } from 'react';

// components
import { Popover } from 'antd';

import classNames from 'classnames';
import { zhAndEnWord } from './constant';

interface IProps {
    isPdf: boolean;
    goPDF: () => void;
    setIsShow: React.Dispatch<React.SetStateAction<boolean>>;
}

const DocFeedback: React.FC<IProps> = props => {
    const { isPdf, goPDF, setIsShow } = props;

    const [pdfStatus, setPdfStatus] = useState(false);
    const [feedbackStatus, setFeedbackStatus] = useState(false);
    const [language] = useState<'zh' | 'en'>(() => (window.location.pathname.includes('/en/') ? 'en' : 'zh'));
    const feedbackRef = useRef<HTMLDivElement>(null);

    return (
        <div className="paddle-doc-feedback-wrap">
            <div className="paddle-doc-feedback" ref={feedbackRef}>
                {language === 'zh' ? (
                    <div className="paddle-doc-feedback-icon">
                        {!pdfStatus ? (
                            <div
                                className="paddle-doc-feedback-pdf"
                                onMouseEnter={() => setPdfStatus(true)}
                                onMouseLeave={() => setPdfStatus(true)}
                            />
                        ) : (
                            <div
                                className={classNames('paddle-doc-feedback-pdf-tips', {
                                    'pdf-tips-disabled': !isPdf
                                })}
                                onMouseEnter={() => setPdfStatus(false)}
                                onMouseLeave={() => setPdfStatus(false)}
                                onClick={() => {
                                    const path = window.location.pathname.includes('lite')
                                        ? 'https://github.com/PaddlePaddle/Paddle-Lite/tree/release/v2.11/docs'
                                        : window.location.pathname.includes('inference')
                                        ? 'https://github.com/PaddlePaddle/Paddle-Inference-Demo/tree/master/docs'
                                        : 'https://github.com/PaddlePaddle/docs';
                                    window.open(path);
                                }}
                            >
                                {/* {zhAndEnWord[language].pdf} */}
                                Edit on Github
                            </div>
                        )}
                        <Popover
                            placement="left"
                            overlayClassName="paddle-doc-feedback-popover"
                            getPopupContainer={() => feedbackRef.current ?? document.body}
                            overlayStyle={{ width: '280px' }}
                            content={
                                <>
                                    <img
                                        className="paddle-doc-feedback-popover-icon"
                                        src={require('./../doc-help/images/feedback-arrow.png')}
                                        alt="反馈提示"
                                    />
                                    <div>
                                        <div className="paddle-doc-feedback-popover-title">
                                            鼠标选取文档内容，精确反馈问题
                                        </div>
                                        <div className="paddle-doc-feedback-popover-desc">
                                            选取您有疑问的文档内容并点击反馈，即可更精确地反馈问题，我们将跟进处理
                                        </div>
                                    </div>
                                </>
                            }
                        >
                            {!feedbackStatus ? (
                                <div
                                    className="paddle-doc-feedback-feedback"
                                    onMouseEnter={() => setFeedbackStatus(true)}
                                    onMouseLeave={() => setFeedbackStatus(true)}
                                />
                            ) : (
                                <div
                                    className="paddle-doc-feedback-feedback-tips"
                                    onMouseEnter={() => setFeedbackStatus(false)}
                                    onMouseLeave={() => setFeedbackStatus(false)}
                                    onClick={() => setIsShow(true)}
                                >
                                    {/* {zhAndEnWord[language].feedback} */}
                                    文档反馈
                                </div>
                            )}
                        </Popover>
                    </div>
                ) : (
                    <div className="paddle-doc-feedback-icon">
                        <Popover placement="left" content={zhAndEnWord[language].pdf}>
                            <div
                                className="paddle-doc-feedback-pdf paddle-doc-feedback-pdf-en"
                                onClick={() => isPdf && goPDF()}
                            />
                        </Popover>
                        <Popover placement="left" content={zhAndEnWord[language].feedback}>
                            <div
                                className="paddle-doc-feedback-feedback paddle-doc-feedback-feedback-en"
                                onClick={() => setIsShow(true)}
                            />
                        </Popover>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DocFeedback;
